import { bemCN } from "../../config/bem-classname";
import "./instruction-pageinstruction-page.scss";
import video from "../../shared/video/ios_save.mp4";
import { ReactComponent as CrossIcon } from "../../shared/images/svg/circle-cross.svg";
import { Button, ButtonColors, ButtonSizes } from "../../ui/button/button";
import { useNavigate } from "react-router";
const instructionPageCn = bemCN("instruction-page");

export const InstructionPage = () => {
  const navigate = useNavigate();
  return (
    <div className={instructionPageCn()}>
      <Button
        text="Закрыть"
        size={ButtonSizes.big}
        color={ButtonColors.pink}
        icon={<CrossIcon />}
        onClick={() => navigate(-1)}
      />
      <video controls autoPlay src={video} />
    </div>
  );
};
